import request from '@/utils/request';

// 获取用户收货地址
export const getUserAddress = (params) => {
  return request({
    url: '/api/core/physical/address',
    method: 'get',
    params,
  })
}

// 新增收货地址
export const addUserAddress = (data) => {
  return request({
    url: '/api/core/physical/address',
    method: "post",
    data
  })
}

// 编辑收货地址
export const editUserAddress = (data, id) => {
  return request({
    url: `/api/core/physical/address/${id}`,
    method: "put",
    data
  })
}

// 获取物流详情
export const getLogisticDetail = (orderNumber) => {
  return request({
    url: `/api/core/physical/shipping/${orderNumber}`,
    method: 'get',
  })
}

// 确定收货
export const receivedMatter = (data) => {
  return request({
    url: "/api/core/physical/received",
    method: "post",
    data,
  });
}

// 售后信息查询
export const getAfterMarketInfo = (orderNumber) => {
  return request({
    url: `/api/core/physical/refund/${orderNumber}`,
    method: "get",
  });
}

// 售后信息提交
export const submitAfterMarketInfo = (data) => {
  return request({
    url: "/api/core/physical/refund/return_evidence",
    method: "post",
    data,
  });
}
